



//   export const imageUploudedControl=(files:FileList)=>{
//    //return ImageInWarehouses.includes(data.type) 

//    Array.from(files).forEach(file=>(
//     imageType.includes(file.type),
//     console.log("Poprawny typ:", imageType.includes(file.type))
//     ))

//}

   export   const imageType: string[] = [
      "image/png",
      "image/gif",
      "image/apng",
      "image/tif",
      "image/bmp",
      "image/jpeg",
      "image/jpg",
      "images/jfif",
    ];
